import { createStore } from "vuex";
import auth from "./modules/auth";
import recovery from "./modules/recovery";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    recovery,
  },
});
